<template>
  <div class="base-flex base-flex__between base-vertical__center boxPadding">
    <div class="base-flex base-flex__between base-cursor__pointer">
      <el-dropdown
        v-if="projectList.length !== 0"
        :popper-append-to-body="false"
        trigger="click"
        @command="handleCommand"
      >
        <span class="el-dropdown-link"> {{ projectName }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
        <el-dropdown-menu class="dropdownList">
          <el-dropdown-item v-for="item in projectList" :key="item.id" :command="item"
            >{{ item.name }}(<span>{{ $t('header.team.id') }}{{ item.id }}</span
            >)
          </el-dropdown-item>
          <div class="base-flex menu_padding_10">
            <el-button @click="createTeamBtn">{{ $t('header.team.create') }}</el-button>
            <el-button type="primary" @click="addTeam">{{ $t('header.team.join') }}</el-button>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="headerNotice">
      <el-dropdown class="base-margin__right-20 base-cursor__pointer" @command="settingsLanguage" v-if="false">
        <span class="el-dropdown-link">
          {{ $t('login.language') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh">中文</el-dropdown-item>
          <el-dropdown-item command="en">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- 上传进度组件 -->
      <UploadProgress />

      <!-- 消息通知管理 -->
      <messageCenter />

      <el-dropdown @command="handleCommandRight">
        <span class="el-dropdown-link">
          <img class="header_img_cls" src="./image/user.png" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <p>{{ userInfo.nickName }}</p>
            <p v-if="userInfo.email" class="email-cls">{{ userInfo.email }}</p>
          </el-dropdown-item>
          <el-dropdown-item command="openBandEmail">
            {{ userInfo.email ? $t('header.user.modifyEmail') : $t('header.user.bindEmail') }}
          </el-dropdown-item>
          <el-dropdown-item command="licensedSoftware">{{ $t('header.user.licensedSoftware') }}</el-dropdown-item>
          <el-dropdown-item command="outLogin">{{ $t('header.user.logout') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <i
        :title="$t('header.user.downloadOECLI')"
        class="el-icon-bangzhu base-margin__left-20 base-cursor__pointer badge-size"
        @click="downloadOecli"
      ></i>
      <i
        :title="$t('header.user.helpCenter')"
        class="el-icon-question base-margin__left-20 base-cursor__pointer badge-size"
        @click="toCourse"
      ></i>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="$t('header.user.licensedSoftware')"
      :visible.sync="dialogVisible"
      width="900px"
    >
      <div>
        <el-button type="primary" @click="activation">
          {{ $t('header.dialog.activateLicense') }}
        </el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" class="table_width">
          <el-table-column :label="$t('header.dialog.userName')" prop="userInfo.name"></el-table-column>
          <el-table-column :label="$t('header.dialog.appName')" prop="applicationInfo.name"></el-table-column>
          <el-table-column :label="$t('header.dialog.createTime')" prop="createTime"></el-table-column>
          <el-table-column :label="$t('header.dialog.expireTime')" width="240">
            <template slot-scope="scope">
              {{ disposeTime(scope.row.expiresAt) }}
              <span v-if="scope.row.expiresAt < currentTime" class="expired_cls">
                {{ $t('header.dialog.expired') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :page-size="10"
          :page-sizes="[10, 20, 50, 100]"
          :total="tableDataTotal"
          align="right"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="onCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog :title="$t('header.dialog.activateLicense')" :visible.sync="activationCodeVisible" width="550px">
      <div class="base-flex">
        <span class="spanCls">{{ $t('header.dialog.licenseCode') }}</span>
        <el-input v-model="codeTextarea" :placeholder="$t('header.dialog.inputLicense')" :rows="6" type="textarea">
        </el-input>
      </div>
      <template #footer>
        <el-button type="primary" @click="activationCode">{{ $t('header.dialog.activate') }}</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { getRequest, postRequest } from '@/common/libs/request';
import messageCenter from '@/components/messageCenter';
import UploadProgress from '@/components/uploadProgress';
import { Message } from 'element-ui';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import { DOWNLOAD_OECLI } from '@/common/constants';
// import { ENV_STATUS_SUCCESS } from '@/common/constants';

export default {
  name: 'headerList',
  components: {
    messageCenter,
    UploadProgress,
  },
  data() {
    return {
      projectList: [],
      projectName: '',
      dialogVisible: false,
      tableData: [],
      pageIndex: 1,
      pageLimit: 10,
      tableDataTotal: 0,
      activationCodeVisible: false,
      codeTextarea: '',
      currentTime: Math.floor(new Date().getTime() / 1000),
      projectListLength: 0,
    };
  },
  async mounted() {
    await this.$store.dispatch('app/getUserInfo');
    await this.$store.dispatch('app/getProjectList');
  },
  watch: {
    'app.projectList'(val) {
      const currentProject = this.getCurrentProject() || {};
      let projectName = currentProject?.name || '';

      if (val[0]?.name !== currentProject?.name) {
        projectName = currentProject.name || val[0].name;
      }

      if (val.length > this.projectListLength && this.projectListLength > 0) {
        projectName = val[0].name;
      }

      if (val.length > 0 && !projectName) {
        projectName = val[0].name;
      }

      if (val.length === 0) {
        if (this.$route.name !== 'dashboard') {
          this.$store.commit('app/setMenuSelectIndex', 0);
          this.$router.push('dashboard');
        }
      }

      this.projectListLength = val.length;
      this.projectList = val;
      this.projectName = projectName;
    },
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
    userInfo() {
      return this.app.userInfo;
    },
  },
  methods: {
    handleCommand(item) {
      this.projectName = item.name;
      this.$store.commit('app/setCurrentProject', item);
    },

    // 设置语言
    settingsLanguage(lang) {
      this.$i18n.locale = lang; // 设置当前语言
      Cookies.set('userLanguage', lang); // 可选：保存用户选择的语言到本地存储
    },
    // 退出登录
    logout() {
      getRequest('/api/common/logout');
      this.$router.replace('/login');
      Cookies.remove('CurrentProjectId');
      window.sessionStorage.removeItem('loginType');
      window.sessionStorage.removeItem('menuIndex');
    },
    handleCommandRight(item) {
      switch (item) {
        case 'secretKey':
          this.$router.push('secretKey');
          break;
        case 'outLogin':
          this.logout();
          break;
        case 'openBandEmail':
          this.openBandEmail();
          break;
        case 'licensedSoftware':
          this.getList();
          this.dialogVisible = true;
          break;
      }
    },
    createTeamBtn() {
      this.$store.commit('app/setTeamIsShow', {
        isShow: true,
        action: 'createTeam',
      });
    },
    addTeam() {
      this.$emit('click', 'apply');
    },
    openBandEmail() {
      this.$emit('click', 'bandEmail');
    },
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      getRequest(`/api/eda/common/eda/describeApplicationsLicense?offset=${offset}&limit=${this.pageLimit}`).then((res) => {
        this.tableData = res.list || [];
        this.tableDataTotal = res.total;
      });
    },
    activation() {
      this.activationCodeVisible = true;
      this.codeTextarea = '';
    },
    activationCode() {
      postRequest('/api/eda/common/eda/activeMarketSkey', {
        skey: this.codeTextarea,
        projectId: this.projectId,
      }).then(() => {
        Message.success(this.$t('header.message.activateSuccess'));
        this.activationCodeVisible = false;
        this.getList();
      });
    },
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },
    disposeTime(val) {
      return dayjs(val * 1000).format('YYYY-MM-DD hh:mm:ss');
    },
    toCourse() {
      if (window.location.host.includes('eda')) {
        window.open('https://eda-static-cdn-1300241787.file.myqcloud.com/build/Production/webdoc/openeda/1.%E8%85%BE%E8%AE%AF%E4%BA%91%E5%AD%90%E8%B4%A6%E5%8F%B7%E7%94%B3%E8%AF%B7.html');
      } else {
        window.open('https://eda-static-cdn-1300241787.file.myqcloud.com/build/Production/webdoc/opencae/1.%E8%85%BE%E8%AE%AF%E4%BA%91%E5%AD%90%E8%B4%A6%E5%8F%B7%E7%94%B3%E8%AF%B7.html');
      }
    },
    downloadOecli() {
      window.open(DOWNLOAD_OECLI);
    },

    async startVnc(projectId) {
      try {
        await postRequest('/api/eda/common/project/startVnc', {
          projectId,
          clientWidth: document.body.offsetWidth,
          clientHeight: document.body.clientHeight - 46,
        });
      } catch (e) {
        this.$message(this.$t('header.message.listFailed'));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// 最外层盒子的padding
.boxPadding {
  padding: 14px 20px 14px;
  // title的文字大小
  .title_cls {
    font-size: 20px;
  }
}

// 头部图片
.header_img_cls {
  width: 20px;
  height: 20px;
  margin-top: 2px;
  margin-left: 10px;
  cursor: pointer;
  vertical-align: top;
}

.menu_padding_10 {
  padding: 10px;
}

// email css
.email-cls {
  font-size: 12px;
  color: #7c878e;
}

.help-circle {
  width: 20px;
  height: 20px;
  margin-left: 20px;
  //position: relative;
  //top: 2px;
  cursor: pointer;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }

  .expired_cls {
    color: red;
  }
}

.spanCls {
  width: 66px;
  line-height: 40px;
}

.dropdownList {
  max-height: 600px !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.el-dropdown-menu {
  max-height: 600px !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.header_notice {
  box-sizing: $base__box_sizing;
}

.badge-size {
  font-size: 20px;
}
</style>
